import { useAuthStore } from '@/store/auth'

export function useReadOnlyScope(scope: 'operations' | 'tron' | 'rewardcode' = 'operations') {
  return useAuthStore(s => !s.isSuperAdmin() && (s.permissions.includes('access:operations:readonly') || s.permissions.includes(`access:${scope}:readonly`)))
}
